<template>
  <SbDropdownGroup :data-testid="dataTestid" :title="title">
    <slot />
  </SbDropdownGroup>
</template>

<script lang="ts" setup>
import { SbDropdownGroup } from '../Dropdown'

type MenuGroupProps = {
  /**
   * The title of the group
   */
  title: string

  /**
   * The data-testid attribute
   */
  dataTestid?: string
}

withDefaults(defineProps<MenuGroupProps>(), {
  dataTestid: 'menu-group',
})
</script>
